import { v4 as uuidV4 } from 'uuid';

import {
  mapPlotterModeToGraphSetType,
  PlotterMode,
} from 'business/data-analysis/constants';
import { ChartType } from 'business/data-analysis/pages/graph/components/chart/types';
import { displayTypes } from 'business/data-analysis/pages/graph/types';

import { GraphPageState, GraphState } from './../types';

export const resetGraphSet = (mode: PlotterMode): GraphPageState => {
  const structure = {
    title: '',
    type: mapPlotterModeToGraphSetType[mode],
    graphs: new Map().set(uuidV4(), {
      title: '',
      displayType: displayTypes.graph,
      chartType:
        mode === PlotterMode.TIME_PERIOD ? ChartType.LINE : ChartType.BAR,
      parameters: new Map(),
      graphNumber: 1,
    } satisfies GraphState),
  };

  return {
    currentGraphId: null,
    displayParameterList: true,
    isLoading: false,
    structure,
    savedState: structuredClone(structure),
  };
};
